import { UdioWrapperConfig } from '../types';
import { UdioWrapper } from '../core/wrapper';

type FetchFunction = typeof fetch;

async function createNodeFetch(): Promise<FetchFunction> {
    // Use native fetch if available (Node.js 18+)
    if (typeof globalThis.fetch === 'function') {
        return globalThis.fetch.bind(globalThis);
    }

    // Fallback to node-fetch
    try {
        // Import node-fetch and use type assertion to handle type compatibility
        const nodeFetchModule = await import('node-fetch');
        return nodeFetchModule.default as unknown as FetchFunction;
    } catch (e) {
        throw new Error('Native fetch is not available. Please use NodeJS 18+ or install node-fetch.');
    }
}

// Create a Udio client for NodeJS environments
export async function createNodeUdioWrapper(
    authToken: string,
    config: UdioWrapperConfig = {}
): Promise<UdioWrapper> {
    const fetchImplementation = config.fetchImplementation || await createNodeFetch();

    return new UdioWrapper(authToken, {
        ...config,
        fetchImplementation,
    });
}